import { Component, Input } from '@angular/core';

@Component({
  selector: 'info-drag-table-permission',
  templateUrl: './info-drag-table-permission.component.html',
  styleUrls: ['./info-drag-table-permission.component.sass']
})
export class InfoDragTablePermissionComponent {
  @Input()permissions: unknown[];
}
